<div style="display: contents;">
    <div class="img-container">
      <img [src]="img" />
    </div>
    <div class="text-container">
      <ng-content></ng-content>
    </div>
    @if (mode=='gradient') {
      <div class="masthead-gradient-background"></div>
    }
</div>
